module.exports.wrapPageElement = require('ocular-gatsby/gatsby-browser').wrapPageElement;
